var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E3C2F0",
    d: "M10.435 5.9c-.487 0-.88-.29-.88-.647v-.485c0-.358.393-.648.88-.648h3.455c.486 0 .88.29.88.648v.485c0 .358-.394.647-.88.647h-3.455z",
    transform: "translate(.324 .803)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9494ED",
    d: "M10.324 3.789c-.55 0-.897-.265-1.051-.559L8.243.91c-.07-.58.378-.91.928-.91 0 0 2.255.315 3.025.315S15.153 0 15.153 0c.55 0 1.012.41.925.867l-.957 2.187c-.257.523-.55.735-1.101.735h-3.696zM11.3 6.267C5.364 6.676.533 11.435.042 17.363c-.196 2.37.289 4.613 1.28 6.554.39.765 1.186 1.239 2.045 1.239h17.59c.853 0 1.648-.465 2.037-1.223.85-1.66 1.33-3.541 1.33-5.534 0-7.002-5.918-12.623-13.026-12.132",
    transform: "translate(.324 .803)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3C2F0",
    d: "M16.054 13.238h-.67c-.227 0-.412.185-.412.412v4.376c0 .115-.05.162-.173.162H12.59c-.12 0-.218-.097-.218-.218v-2.088c0-.227-.185-.413-.413-.413h-.571c-.228 0-.413.186-.413.413v3.432c0 .227.185.412.413.412h3.866c.691 0 1.213-.526 1.213-1.224V13.65c0-.227-.185-.412-.413-.412",
    transform: "translate(.324 .803)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3C2F0",
    d: "M12.903 15.232v1.861c0 .228.186.412.412.412h.562c.228 0 .413-.184.413-.412v-2.349c0-.849-.691-1.539-1.54-1.539H9.778c-.54 0-.98.44-.98.981v5.127c0 .228.185.413.412.413h.68c.229 0 .414-.185.414-.413v-4.352c0-.12.097-.217.217-.217h1.893c.27 0 .49.219.49.488",
    transform: "translate(.324 .803)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.186cc8c1230cc2ef3c55b844079c5fe9.svg";
export { ForwardRef as ReactComponent };